import { UserInterface } from '@app/models/user';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../withTypes';
import { getProfile, getUserWithBusinesses } from '@app/services/user';

export interface AuthState {
  user: UserInterface | undefined;
  isLoading: boolean;
}

const initialState: AuthState = {
  user: undefined,
  isLoading: false,
};

export const fetchUpdate = createAppAsyncThunk('auth/fetchUpdate', async () => {
  const response = await getProfile();
  return response?.data;
});

export const fetchMe = createAppAsyncThunk('auth/fetchMe', async () => {
  const response = await getUserWithBusinesses();
  return response?.data?.user;
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    save: (state, action: PayloadAction<UserInterface>) => {
      state.user = action.payload;
      state.isLoading = false;
    },
    update: (state, action: PayloadAction<UserInterface>) => {
      state.user = { ...state.user, ...action.payload };
    },
    logout: (state) => {
      localStorage?.removeItem('accessToken');
      localStorage?.removeItem('googleAccessToken');
      localStorage?.removeItem('userPlanTypes');
      localStorage?.removeItem('impersonation');
      localStorage?.removeItem('adminToken');
      localStorage?.removeItem('businessId');
      state.user = undefined;
      state.isLoading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUpdate.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchMe.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMe.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUpdate.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(fetchMe.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { save, update, logout, setLoading } = authSlice.actions;

export default authSlice.reducer;
